import { connect } from "react-redux";
import IconButton from "@material-ui/core/IconButton";
import HighlightOffIcon from "@material-ui/icons/HighlightOff";
import config from "../../../utils/config";
import { separateNum } from "../../../utils";
import { Modal } from "../../../components/dialog";
import {
  Div,
  ContainerDetail,
  HeaderDetail,
  HeaderDetailTitle,
  DetailLabel,
  DetailValue,
  ContentDetail,
  FooterDetail,
} from "./style";

const Detail = (props) => {
  const { data, refrence, theme } = props;

  return (
    <>
      <Modal ref={refrence} listClassName="max-height-100">
        <ContainerDetail className="p-3 text-right">
          <HeaderDetail className="mb-2" theme={theme}>
            <Div className="mb-4">
              <HeaderDetailTitle theme={theme}>فاکتور</HeaderDetailTitle>
              <IconButton
                className="float-left p-0"
                color="inherit"
                onClick={() => refrence.current.changeStatus()}
              >
                <HighlightOffIcon />
              </IconButton>
            </Div>
            {/* Item */}
            {data.items.length ? (
              <>
                {data.items.map((item, index) => (
                  <Div key={index} className="mb-3">
                    <DetailLabel theme={theme}>
                      {item?.product?.name} ({item?.count})
                    </DetailLabel>
                    <DetailValue className="float-left mr-1" theme={theme}>
                      {config.currency}
                    </DetailValue>
                    <DetailValue className="float-left" theme={theme}>
                      {separateNum(item?.total)}
                    </DetailValue>
                  </Div>
                ))}
              </>
            ) : (
              false
            )}
            {/* Item */}
          </HeaderDetail>
          <ContentDetail className="mb-2" theme={theme}>
            <Div className="mb-3">
              <DetailLabel theme={theme}>مجموع سفارش</DetailLabel>
              <DetailValue className="float-left mr-1" theme={theme}>
                {config.currency}
              </DetailValue>
              <DetailValue className="float-left" theme={theme}>
                {separateNum(data?.items_total)}
              </DetailValue>
            </Div>
            <Div className="mb-3">
              <DetailLabel className="color-red" theme={theme}>
                تخفیف
              </DetailLabel>
              <DetailValue className="float-left mr-1 color-red" theme={theme}>
                {config.currency}
              </DetailValue>
              <DetailValue className="float-left color-red" theme={theme}>
                {separateNum(data?.items_offer)}
              </DetailValue>
            </Div>
            <Div className="mb-3">
              <DetailLabel theme={theme}>هزینه ارسال</DetailLabel>
              <DetailValue className="float-left mr-1" theme={theme}>
                {config.currency}
              </DetailValue>
              <DetailValue className="float-left" theme={theme}>
                {separateNum(data?.shipping_price)}
              </DetailValue>
            </Div>
            <Div className="mb-3">
              <DetailLabel theme={theme}>بسته بندی</DetailLabel>
              <DetailValue className="float-left mr-1" theme={theme}>
                {config.currency}
              </DetailValue>
              <DetailValue className="float-left" theme={theme}>
                {separateNum(data?.packing_price)}
              </DetailValue>
            </Div>
            <Div className="mb-3">
              <DetailLabel theme={theme}>مالیات</DetailLabel>
              <DetailValue className="float-left mr-1" theme={theme}>
                {config.currency}
              </DetailValue>
              <DetailValue className="float-left" theme={theme}>
                {separateNum(data?.tax)}
              </DetailValue>
            </Div>
          </ContentDetail>
          <FooterDetail>
            <DetailLabel theme={theme}>جمع کل</DetailLabel>
            <DetailValue className="float-left mr-1" theme={theme}>
              {config.currency}
            </DetailValue>
            <DetailValue className="color-app float-left" theme={theme}>
              {separateNum(data?.payable)}
            </DetailValue>
          </FooterDetail>
        </ContainerDetail>
      </Modal>
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    theme: state.theme,
  };
};

export default connect(mapStateToProps, false)(Detail);
